var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.581,
    height: 55.925,
    viewBox: "0 0 31.581 55.925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642",
    transform: "translate(-820.144 -1563.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-shield",
    "data-name": "Icon feather-shield",
    d: "M21.791,42.477s15.791-7.9,15.791-19.738V8.921L21.791,3,6,8.921V22.738C6,34.581,21.791,42.477,21.791,42.477Z",
    transform: "translate(814.144 1576.542)",
    fill: "#08652a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-shield-2",
    "data-name": "Icon feather-shield",
    d: "M21.791,42.477s15.791-7.9,15.791-19.738V8.921L21.791,3,6,8.921V22.738C6,34.581,21.791,42.477,21.791,42.477Z",
    transform: "translate(814.144 1568.318)",
    fill: "#439a63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-shield-3",
    "data-name": "Icon feather-shield",
    d: "M21.791,42.477s15.791-7.9,15.791-19.738V8.921L21.791,3,6,8.921V22.738C6,34.581,21.791,42.477,21.791,42.477Z",
    transform: "translate(814.144 1560.094)",
    fill: "#d5ecd9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5);
export default __webpack_public_path__ + "static/media/Group5.43cef97fdb4e7b7f36e2cc885ebd9e6a.svg";
export { ForwardRef as ReactComponent };